var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"backInfoMain2",attrs:{"id":"loadingPage"}},[_c('b-container',{staticClass:"bv-example-row",staticStyle:{"height":"AUTO","border":"0px solid rgb(164, 164, 169)"}},[_c('br'),_c('b-progress',{attrs:{"striped":"","value":_vm.value,"max":_vm.max,"precision":2,"show-progress":"","animated":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }